import Icon from "@client/controls/Icon/component";
import { BackgroundContainer } from "@client/controls/Style/Background/container";
import { exitIframe } from "@client/lib/misc";
import { IconType } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import { getIsIframed } from "@common/lib/url";
import * as React from "react";
import Assets from "./Assets/component";

export type MapProps = WithChildren & {
  style: React.CSSProperties;
};
export default (props: MapProps) => (
  <div id="wsc_html_container" style={props.style}>
    <Assets />

    <BackgroundContainer containerSelector="#wsc_html_container" />

    {props.children}

    {getIsIframed() && <Icon className="exit_iframe" iconClassName={IconType.Cross} onClick={() => exitIframe()} />}
  </div>
);
